import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { create } from 'zustand'

interface MarketInfoWethPriceStore {
  wethPrice: NormalizedNumber | undefined
  setWethPrice: (wethPrice: NormalizedNumber | undefined) => void
}

export const useMarketInfoWethPriceStore = create<MarketInfoWethPriceStore>((set) => ({
  wethPrice: undefined,
  setWethPrice: (wethPrice) => set({ wethPrice }),
}))
